module.exports = __webpack_public_path__ + "static/img/ue_bw.825033a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ue_bw.png
// module id = LuKC
// module chunks = 0